/**
 * Intervalo "Personalizado" do `PeriodPicker` (`yyyy-mm-dd` → instantes).
 *
 * Do primeiro dia à meia-noite até o último instante do dia final, NO FUSO do
 * navegador. Mandar só `yyyy-mm-dd` faria o servidor contar o dia em UTC e a
 * resposta das 22h de ontem cairia em "hoje".
 */

/** `yyyy-mm-dd` → meia-noite local daquele dia. */
export const localDayStart = (ymd: string): Date =>
  new Date(Number(ymd.slice(0, 4)), Number(ymd.slice(5, 7)) - 1, Number(ymd.slice(8, 10)));

export const customRangeToIso = (start: string, end: string): { startDate: string; endDate: string } => {
  const depoisDoFim = localDayStart(end);
  depoisDoFim.setDate(depoisDoFim.getDate() + 1);
  return {
    startDate: localDayStart(start).toISOString(),
    endDate: new Date(depoisDoFim.getTime() - 1).toISOString(),
  };
};
